import React from 'react';
import RainfallChart from '../../../../../../components/Highcharts/RainfallChart/RainfallChart';
import Et0Chart from '../../../../../../components/Highcharts/Et0Chart/Et0Chart';
import KcChart from '../../../../../../components/Highcharts/KcChart/KcChart';
import HumidityTemperatureChart from '../../../../../../components/Highcharts/LineCharts/HumidityTemperatureChart/HumidityTemperatureChart';
import ColdHoursChart from '../../../../../../components/Highcharts/LineCharts/ColdHoursChart/ColdHoursChart';
import ChillPortionsChart from '../../../../../../components/Highcharts/LineCharts/ChillPortionsChart/ChillPortionsChart';
import DegreeDayChart from '../../../../../../components/Highcharts/DegreeDayChart/DegreeDayChart';
import { DEFAULT_COLD_HOURS_CONFIG } from '../../../../../../components/Highcharts/LineCharts/ColdHoursChart/types';
import WindChart from '../../../../../../components/Highcharts/LineCharts/WindChart/WindChart';
import RadiationChart from '../../../../../../components/Highcharts/LineCharts/RadiationChart/RadiationChart';
import DpvChart from '../../../../../../components/Highcharts/LineCharts/DpvChart/DpvChart';

const WeatherChartsTab = ({
  sectorId, farmId, hideKc,
}: { sectorId: string, farmId: string, hideKc?: boolean }) => (
  <>
    {!hideKc && (
      <KcChart
        chartView="graphs"
        sectorId={sectorId}
        farmId={farmId}
      />
    )}
    <RainfallChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
    />
    <Et0Chart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
    />
    <DpvChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={450}
    />
    <HumidityTemperatureChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={450}
    />
    <ColdHoursChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={450}
      config={DEFAULT_COLD_HOURS_CONFIG}
    />
    <ChillPortionsChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={450}
    />
    <DegreeDayChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={450}
    />
    <WindChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={450}
    />
    <RadiationChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={450}
    />
  </>
);

export default WeatherChartsTab;
